export let API_URL = `${
  process.env[`REACT_APP_` + process.env.REACT_APP_MODE + `_API_URL`]
}/api/v1`

export let HTML_URL = `${
  process.env[`REACT_APP_` + process.env.REACT_APP_MODE + `_API_URL`]
}`
export let IMG_URL = `${
  process.env[`REACT_APP_` + process.env.REACT_APP_MODE + `_IMAGE`]
}`
export const API = {
  // API_URL

  // 로그인 인증번호 발송
  LOGIN_CERTIFICATION: `${API_URL}/members/loginCertification`,

  // 로그인 인증번호 확인
  LOGIN_PROC: `${API_URL}/members/loginProc`,

  // 로그인 아이디 찾기 인증번호 발송
  FIND_ID_CERTIFICATION: `${API_URL}/members/findIdCertification`,

  // 로그인 아이디 찾기 인증번호 확인
  FIND_ID_PROC: `${API_URL}/members/findIdProc`,

  //  기존: resetPassword
  //  new: changePassword
  // // 로그인 비밀번호 초기화 인증번호 발송
  // RESET_PWD_CERTIFICATION: `${API_URL}/members/resetPwdCertification`,

  // // 로그인 비밀번호 초기화 인증번호 확인
  // RESET_PWD_PROC: `${API_URL}/members/resetPwdProc`,

  // // 비밀번호 초기화
  // RESET_PASSSWORD: `${API_URL}/members/resetPassword`,
  //  new: changePassword
  CHANGE_PWD_CERTIFICATION: `${API_URL}/members/changePwdCertification`, //기존: RESET_PWD_CERTIFICATION resetPwdCertification
  CHANGE_PWD_PROC: `${API_URL}/members/changePwdProc`, //기존: resetPwdProc
  CHANGE_PASSSWORD: `${API_URL}/members/changePassword`, //기존: resetPassword

  //  기존:  changePassword
  //  new: resetPassword
  // 비밀번호 초기화
  RESET_PASSSWORD: `${API_URL}/members/resetPassword`, //기존: CHANGE_PASSSWORD

  // 로그인 정보 조회
  GET_MEMBER: `${API_URL}/members/info`,

  // 공지사항 목록
  NOTICE_LIST: `${API_URL}/notices`,

  // 공지사항 상세
  NOTICE_DETAIL: `${API_URL}/notices/details`,

  // 상품 목록, 판매/비판매 상태 변경
  PRODUCTS: `${API_URL}/products`,

  // 옵션 목록, 판매/비판매 상태 변경
  OPTIONS: `${API_URL}/options`,

  // 상품 상태이력 조회
  // PRODUCTS_HISTORY: `${API_URL}/products/histories`,

  // 리뷰(조회,등록)
  REVIEW: `${API_URL}/reviews`,

  // 매장(조회,변경)
  STORES_INFO: `${API_URL}/stores`,

  // error test
  //STORES: `${API_URL}/dddddddas`,

  // 매장 배달 정보 변경
  STORE_DELIVERY: `${API_URL}/stores/deliveries`,

  // 매장 해피오더 정보 변경
  STORE_HAPPY_ORDER: `${API_URL}/stores/happy-orders`,

  // 주문 조회
  ORDERS_LIST: `${API_URL}/orders`,

  // 정산 조회
  SETTLEMENT_LIST: `${API_URL}/calculations/list`,

  // 정산 목록(엑셀)
  SETTLEMENT_EXCEL: `${API_URL}/calculations/excels`,

  // 정산 상세(엑셀)
  SETTLEMENT_EXCEL_DETAIL: `${API_URL}/calculations/excelDetail`,

  // 통계 요약
  STAT_SUMMARY: `${API_URL}/stats/totals`,

  // 통계 차트
  STAT_CHART: `${API_URL}/stats`,

  // 통계 테이블 엑셀
  STAT_EXCEL: `${API_URL}/stats/excels`,

  // 대시보드
  DASHBOARD: `${API_URL}/home`,

  // 테스트(응답 강제 펜딩 테스트)
  TEST: `${API_URL}/members/test`,

  // FAQ
  FAQ_LIST: `${API_URL}/faq/getFaqList`,

  // 약관 목록(드롭다운)
  // TERM_LIST: `${API_URL}/term/terms`,

  //  약관 상세
  // TERM_DETAIL: `${API_URL}/term/termDetail`,

  //  약관 동의
  // TERM_AGREE: `${API_URL}/term/userTerms`,

  // 약관 동의(팝업창 리스트)
  TERM_LIST: `${API_URL}/term/termsList`,

  // 약관 최초동의
  TERM_AGREE_LIST: `${API_URL}/term/termAgree`,

  // 약관 재동의
  TERM_REAGREE_LIST: `${API_URL}/term/termReAgree`,

  // 약관 동의 등록
  TERM_AGREE: `${API_URL}/term/userTerms`,

  // 로그아웃(세션 초기화 / 인증번호 오류 관련 처리)
  SIGN_OUT: `${API_URL}/members/logout`,

  // 배달 지역(좌표)
  DELIVERY_MAP: `${API_URL}/deliveryMaps`,

  // /agentPOS redirect할 페이지 로그 히스토리
  PAGE_REDIRECT_LOG: `${API_URL}/routeHistory/redirect`,

  // POS 다운로드
  POS_DOWNLOAD:
    process.env[`REACT_APP_` + process.env.REACT_APP_MODE + `_POS_DOWNLOAD`] +
    '/appService/v1/download?appId=1',

  // 보안패치 다운로드
  SECURITY_DOWNLOAD:
    process.env[`REACT_APP_` + process.env.REACT_APP_MODE + `_POS_DOWNLOAD`] +
    '/appService/v1/download?appId=99',

  // 히스토리
  WORK_HISTORY_ORDER: `${API_URL}/history/order`,

  // 부가세 신고자료
  VAT_MONTH_SUMMARY: `${HTML_URL}/api/vat/report/summary`,
  VAT_QUARTER_SUMMARY: `${HTML_URL}/api/vat/report/quarter/summary`,
  VAT_MONTH_EXCEL_DOWNLOAD: `${HTML_URL}/download/exportStoreVatReportExcelFile`,
  VAT_QUARTER_EXCEL_DOWNLOAD: `${HTML_URL}/download/exportQuarterVatSummaryExcelFile`,
}

export const CURRENT_URL = {
  HOME: '/',
  SIGN_IN: 'signin',
  ORDER_LIST: 'OrderList',
  ITEM_LIST: 'itemList',
  STORE_LIST: 'storeList',
  STORE_MANAGE: 'manageStoreInfo',
  STORE_DELIVERY_INFO: 'storeDeliveryInfo',
  SETTLEMENTS: 'settlements',
  VAT_LIST: 'vatList',
  TOTAL_ORDER: 'totalOrder',
  REVIEW_LIST: 'reviewList',
  NOTICE_LIST: 'NoticeList',
  VAT_REPORT: 'vatReport',
  NOTICE_HAPPY_ORDER: 'happyOrderNoticeList',
  NOTICE_STORE: 'storeNoticeList',
  SERVICE_TERMS: 'serviceterms',
  PRIVACY_TERMS: 'privacyterms',
}

export const SHOW_MENU_USER_ID_LIST = ['EXAG0003']

export const BRAND_IMG_VERSION = '1.0'
